import { action } from 'easy-peasy';
import { Status } from '~/services/api/actTeamMember/types';
import { IActionRestoreGlobalUser } from '../types';

const restoreGlobalUser: IActionRestoreGlobalUser = action((state, teamMemberId) => {
  const updatedList = state.availableList.map(item =>
    item.id !== teamMemberId ? item : { ...item, status: 'Active' as Status },
  );
  state.availableList = updatedList;
});

export default restoreGlobalUser;
